import clsx from "clsx";
import * as React from "react";

const DataList = ({items, columns, className, style, ...others}) => {
  return (
    <div className={clsx('data-list', className)} style={{"--data-list-columns": columns, ...style}} {...others}>
      {items.map((item, idx) => (
        <div key={idx} className="data-item">
          <div className="data-item__label">{item.label}</div>
          <div className="data-item__value">{item.value}</div>
        </div>
      ))}
    </div>
  );
}

export default DataList;
